import React from "react";
import PositionEditorModal from "@/appComponents/Blocks/Modals/RecordEditorModal/PositionEditorModal";
import { usePlanManagerContext } from "@/providers/PlanManagerProvider";
import { GetWSMgr } from "@/Utils/StateLib";

export const PlanManagerPositionEditorModal = () => {
  const {
    recordEditorContextValue: {
      theData,
      showPositionEditor,
      onSaveRecordEdit,
      onClosePositionEditor
    }
  } = usePlanManagerContext();

  const wsMgr = GetWSMgr();
  const manager = wsMgr?.GetPlanMgr();

  if (!showPositionEditor) return null;

  return (
    <PositionEditorModal
      theData={theData}
      showPositionEditor={showPositionEditor}
      onSaveRecordEdit={onSaveRecordEdit}
      onClosePositionEditor={onClosePositionEditor}
      manager={manager}
    />
  );
};
